<template>
  <div class="user-menu-component">
    <div class="menu-container">
      <QList>
        <MenuItem icon="fal fa-store" :label="t('ETAB.PAGES.DASHBOARD.USER_MENU.@ETAB')" @on-action="emit('onClickEtab')" />

        <QSeparator inset />

        <MenuItem icon="fal fa-gear" :label="t('ETAB.PAGES.DASHBOARD.USER_MENU.@INFORMATIONS')" @on-action="emit('onClickInformations')" />

        <!-- Payment means -->
        <template v-if="!isMasterEtabWithoutSupervisedEtab">
          <QSeparator inset />
          <MenuItem
            icon="fal fa-folder-open"
            :label="t('ETAB.PAGES.DASHBOARD.USER_MENU.@ETAB_ADMIN_FOLDER')"
            @on-action="emit('onClickEtabAdminFolder')"
          />
        </template>

        <!-- ABO -->
        <template v-if="!isMasterEtabWithoutSupervisedEtab">
          <QSeparator inset />
          <MenuItem icon="fal fa-medal" :label="t('ETAB.PAGES.DASHBOARD.USER_MENU.@ABO')" @on-action="emit('OnClickSubscription')" />
        </template>

        <QSeparator v-if="!isMasterEtabWithoutSupervisedEtab" inset />

        <MenuItem
          icon="fal fa-location-plus"
          :label="isMasterEtab ? t('ETAB.PAGES.DASHBOARD.USER_MENU.@MULTI_ACCOUNT') : t('ETAB.PAGES.DASHBOARD.USER_MENU.@ADD_ETAB')"
          @on-action="emit('onClickMultiAccount')"
        />

        <QSeparator inset />

        <MenuItem icon="fal fa-circle-question" :label="t('ETAB.PAGES.DASHBOARD.USER_MENU.@NEED_HELP')" @on-action="emit('onClickHelp')" />

        <QSeparator inset />

        <MenuItem v-if="isDevelopmentContext(environment)" icon="fal fa-code" :label="t('Développeurs')" @on-action="emit('onClickDeveloperTools')" />

        <QSeparator v-if="isDevelopmentContext(environment)" inset />

        <MenuItem icon="fal fa-arrow-right-from-bracket" :label="t('ETAB.PAGES.DASHBOARD.USER_MENU.@LOGOUT')" @on-action="emit('onClickLogout')" />
      </QList>
    </div>
  </div>
</template>
<script setup>
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";

  import { isDevelopmentContext } from "@extracadabra/core-v2";
  import MenuItem from "@core/components/common/MenuItem.functional.vue";

  const { t } = useI18n();

  const { isMasterEtab, isMasterEtabWithoutSupervisedEtab } = defineProps({
    isMasterEtab: {
      type: Boolean,
      default: false,
    },
    isMasterEtabWithoutSupervisedEtab: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    "onClickEtab",
    "onClickInformations",
    "onClickEtabAdminFolder",
    "OnClickSubscription",
    "onClickMultiAccount",
    "onClickHelp",
    "onClickLogout",
    "onClickDeveloperTools",
  ]);

  const environment = computed(() => process.env.APP_ENV);
</script>
